import { Breadcrumb, Button, Card, Empty, Table } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';

import {
  MarketActivityType,
  MarketingActivityRule,
  MarketingActivityRuleKey,
  ReservationCommonSchema,
} from '../../types/marketingActivity';

export const getActivitiesList = gql`
  query getActivitiesQuery($types: [ID], $activityIds: [ID]) {
    activities(types: $types, activityIds: $activityIds) {
      id
      name
      rules {
        id
        activityId
        remark
        ruleKey
        ruleName
        ruleType
        ruleValue
      }
    }
  }
`;

export interface MarketingActivityData {
  activities: {
    name: string;
    id: number;
    rules: MarketingActivityRule[];
  }[];
}

export interface MarketingActivityTableData {
  key: number;
  id: number;
  activitiyName: string;
  enrollmentGroupCounts: number;
  reservationRange: string;
  saleRange: string;
}

interface State {
  isAddModalVisible: boolean;
}

interface Props {}

export class ReserveActivities extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isAddModalVisible: false,
    };
  }

  render() {
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>营销活动</Breadcrumb.Item>
        </Breadcrumb>
        <Query<MarketingActivityData> query={getActivitiesList} variables={{ types: [MarketActivityType.RESERVATION] }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const activities = (data && data.activities) || [];
            const dataSource = activities.map(activitiy => {
              const reservationDate = activitiy.rules.find(
                rule => rule.ruleKey === MarketingActivityRuleKey.DETAIL_RESERVATION_COMMON,
              );

              const ruleValue = reservationDate && (reservationDate.ruleValue as ReservationCommonSchema);

              let enrollmentGroupCounts = 0;

              for (const rule of activitiy.rules) {
                if (rule.ruleKey === MarketingActivityRuleKey.DETAIL_RESERVATION_DISCOUNT) {
                  enrollmentGroupCounts += 1;
                }
              }

              return {
                enrollmentGroupCounts,
                activitiyName: activitiy.name,
                id: activitiy.id,
                key: activitiy.id,
                reservationRange:
                  (ruleValue &&
                    `${moment(ruleValue.reservationStartAt).format('L')}-${moment(ruleValue.reservationEndAt).format(
                      'L',
                    )}`) ||
                  '-',
                saleRange:
                  (ruleValue &&
                    `${moment(ruleValue.saleStartAt).format('L')}-${moment(ruleValue.saleEndAt).format('L')}`) ||
                  '-',
              };
            });

            return (
              <Card title="营销管理">
                <Card type="inner" title="预约制续费">
                  <Table
                    size="small"
                    columns={[
                      {
                        title: 'ID',
                        key: 'id',
                        dataIndex: 'id',
                        width: '5%',
                      },
                      {
                        title: '活动名称',
                        key: 'activitiyName',
                        dataIndex: 'activitiyName',
                      },
                      {
                        title: '社群数',
                        key: 'enrollmentGroupCounts',
                        dataIndex: 'enrollmentGroupCounts',
                        width: '8%',
                      },
                      {
                        title: '预约时间',
                        key: 'reservationRange',
                        dataIndex: 'reservationRange',
                        width: '15%',
                      },
                      {
                        title: '报名时间',
                        key: 'saleRange',
                        dataIndex: 'saleRange',
                        width: '15%',
                      },
                      {
                        title: '操作',
                        key: 'operation',
                        dataIndex: 'id',
                        width: '30%',
                        render: (text, record) => {
                          return (
                            <>
                              <Button style={{ marginRight: '10px', marginBottom: '3px' }} type="primary">
                                <Link to={`/marketing/${record.id}/robots`}>添加水军</Link>
                              </Button>
                              <Button type="primary" style={{ marginRight: '10px', marginBottom: '3px' }}>
                                <Link to={`/marketing/${record.id}/config`}>活动配置</Link>
                              </Button>
                              <Button type="primary" style={{ marginRight: '10px', marginBottom: '3px' }}>
                                <Link to={`/marketing/${record.id}/rule`}>规则配置</Link>
                              </Button>
                            </>
                          );
                        },
                      },
                    ]}
                    dataSource={dataSource}
                  />
                </Card>
              </Card>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/ReserveActivities.tsx